import { SHOW_SNACK } from "@/store/snack.module";

export default {
  methods: {
    deliveryNoteProduct(productId) {
      return (this.document.delivery_note?.products || []).find(
        (product) => Number(product.stock_product_id) === Number(productId)
      );
    },
    documentQuantityForProduct(productId) {
      return (this.lines || [])
        .filter((line) => Number(line.stock_product_id) === Number(productId))
        .reduce((sum, line) => sum + Number(line.quantity || 0), 0);
    },
    lineMismatchesDeliveryNote(line) {
      if (
        this.isReadOnlyDocument ||
        !this.document.stock_delivery_note_id ||
        !this.document.delivery_note ||
        !line?.stock_product_id
      ) {
        return false;
      }

      const noteProduct = this.deliveryNoteProduct(line.stock_product_id);
      if (!noteProduct) {
        return true;
      }

      return (
        Math.abs(this.documentQuantityForProduct(line.stock_product_id) - Number(noteProduct.quantity)) >
        0.0001
      );
    },
    deliveryNoteQuantityHint(line) {
      const note = this.document.delivery_note;
      const noteProduct = this.deliveryNoteProduct(line.stock_product_id);
      const noteQty = noteProduct ? Number(noteProduct.quantity) : 0;
      const docQty = this.documentQuantityForProduct(line.stock_product_id);

      return this.$t("STOCK.COMMON.DELIVERY_NOTE_QTY_MISMATCH", {
        product: noteProduct?.display_name || this.lineProductLabel(line),
        note: note?.code || "",
        noteQty: this.formatDeliveryNoteQty(noteQty),
        docQty: this.formatDeliveryNoteQty(docQty),
        unit: noteProduct?.unit_code || this.lineUnitCode(line) || "kg",
      });
    },
    deliveryNoteQuantityMismatchMessage() {
      const seen = new Set();
      const messages = [];

      (this.lines || []).forEach((line) => {
        const productId = Number(line.stock_product_id);
        if (!productId || seen.has(productId) || !this.lineMismatchesDeliveryNote(line)) {
          return;
        }
        seen.add(productId);
        messages.push(this.deliveryNoteQuantityHint(line));
      });

      return messages.join(" ");
    },
    validateDeliveryNoteQuantitiesOrNotify() {
      const message = this.deliveryNoteQuantityMismatchMessage();
      if (!message) {
        return true;
      }

      this.$store.dispatch(SHOW_SNACK, { message, color: "error" });
      return false;
    },
    formatDeliveryNoteQty(value) {
      const rounded = Math.round(Number(value) * 10000) / 10000;
      return Number.isInteger(rounded) ? String(rounded) : String(rounded);
    },
    linkedDeliveryNotes() {
      return this.document.delivery_note?.id ? [this.document.delivery_note] : [];
    },
  },
};
